import { Col, Divider, Row } from 'antd';
import { MyPageUserInfo } from 'domain/entities/UserEntity';
import { FormInput } from 'presentation/components/form/FormInput.component';
import UploadImage from './Upload';
import { useState } from 'react';

interface props {
    data?: MyPageUserInfo;
    form: any;
    onChangeForm: (value?: any) => void;
    requiredFileTaxSlip: boolean;
    requiredFileFinalReport: boolean;
}

export const RegistrationStepTwo = ({ data, form, onChangeForm, requiredFileTaxSlip, requiredFileFinalReport }: props) => {
    const [requiredLoanAmountHouse, setRequiredLoanAmountHouse] = useState<boolean>(false);
    const [requiredLoanAmountCar, setRequiredLoanAmountCar] = useState<boolean>(false);
    const [requiredLoanAmountProperty, setRequiredLoanAmountProperty] = useState<boolean>(false);
    const [requiredLoanAmountOther, setRequiredLoanAmountOther] = useState<boolean>(false);
    return (
        <>
            <Row className="min-w-min">
                <div className="w-full mb-[48px]">
                    <span className="content-step-form heading-step-form">収入証明</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={24} className="pr-[12px]">
                            <span className="content-step-form label-step-form">
                                給与所得者は以下のいずれか
                            </span>
                            <span className="content-step-form label-step-form dotted-text">
                                源泉徴収票
                            </span>
                            <span className="content-step-form label-step-form dotted-text">
                                確定申告書及び付属明細（確定申告している場合）
                            </span>
                            <span className="content-step-form label-step-form">
                                ※いずれも直近のもの
                            </span>
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={24} className="pr-[12px]">
                            <span className="content-step-form label-step-form">
                                個人事業主は以下
                            </span>
                            <span className="content-step-form label-step-form dotted-text">
                                確定申告書及び付属明細（直近1期分）
                            </span>
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={24} className="pr-[12px]">
                            <span className="content-step-form label-step-form">
                                会社経営者は以下のいずれか
                            </span>
                            <span className="content-step-form label-step-form dotted-text">
                                源泉徴収票
                            </span>
                            <span className="content-step-form label-step-form dotted-text">
                                確定申告書及び付属明細（確定申告している場合）
                            </span>
                            <span className="content-step-form label-step-form">
                                ※いずれも直近1期分
                            </span>
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="所得額"
                                name="income"
                                type="number"
                                required
                                maxLength={10}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                suffix="万円"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px] ant-col-upload">
                            <UploadImage
                                initialImageUrl={data?.fileIncomeTax}
                                imageId={
                                    data?.fileIncomeTaxId
                                        ? Number(data?.fileIncomeTaxId)
                                        : undefined
                                }
                                required={requiredFileTaxSlip}
                                form={form}
                                name="fileIncomeTax"
                                title="収入証明（源泉徴収票）をアップロード"
                                onChange={onChangeForm}
                                editName="isEditFileTax"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px] ant-col-upload">
                            <UploadImage
                                required={requiredFileFinalReport}
                                initialImageUrl={data?.fileIncomeFinal}
                                imageId={
                                    data?.fileIncomeFinalId
                                        ? Number(data?.fileIncomeFinalId)
                                        : undefined
                                }
                                form={form}
                                name="fileIncomeFinal"
                                title="収入証明（確定申告書及び付属証明書）をアップロード"
                                onChange={onChangeForm}
                                editName="isEditFileReport"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="w-full mb-[48px]">
                    <span className="content-step-form heading-step-form">借入証明</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={24} className="pr-[12px]">
                            <span className="content-step-form label-step-form">ローン返済表</span>
                            <span className="content-step-form label-step-form">
                                <p className="mt-[0] mr-[5px] mb-[0] ml-[5px]">1.</p>自宅
                            </span>
                            <span className="content-step-form label-step-form">
                                <p className="mt-[0] mr-[5px] mb-[0] ml-[5px]">2.</p>自動車
                            </span>
                            <span className="content-step-form label-step-form">
                                <p className="mt-[0] mr-[5px] mb-[0] ml-[5px]">3.</p>
                                投資用不動産
                            </span>
                            <span className="content-step-form label-step-form">
                                ※いずれも直近のもの
                            </span>
                            <span className="content-step-form label-step-form">
                                ※借入額が存在する場合、金額を記載のうえ該当する書類のアップロードが必要です
                            </span>
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="借入額（自宅）"
                                name="loanAmountHouse"
                                type="number"
                                required
                                maxLength={10}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                suffix="万円"
                                onChange={(e) => {
                                    setRequiredLoanAmountHouse(e > 0);
                                }}
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormInput
                                label="借入額（自動車）"
                                name="loanAmountCar"
                                type="number"
                                required
                                maxLength={10}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                suffix="万円"
                                onChange={(e) => {
                                    setRequiredLoanAmountCar(e > 0);
                                }}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px] mb-[24px] ant-col-upload">
                            <UploadImage
                                required={requiredLoanAmountHouse}
                                form={form}
                                initialImageUrl={data?.fileLoanHouse}
                                imageId={
                                    data?.fileLoanHouseId
                                        ? Number(data?.fileLoanHouseId)
                                        : undefined
                                }
                                name="fileLoanHouse"
                                title="借入証明（自宅）をアップロード"
                                onChange={onChangeForm}
                                editName="isEditFileHouse"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px] mb-[24px] ant-col-upload">
                            <UploadImage
                                required={requiredLoanAmountCar}
                                initialImageUrl={data?.fileLoanCar}
                                imageId={
                                    data?.fileLoanCarId ? Number(data?.fileLoanCarId) : undefined
                                }
                                form={form}
                                name="fileLoanCar"
                                title="借入証明（自動車）をアップロード"
                                onChange={onChangeForm}
                                editName="isEditFileCar"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <FormInput
                                label="借入額（投資用不動産）"
                                name="loanAmountProperty"
                                type="number"
                                required
                                maxLength={10}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                suffix="万円"
                                onChange={(e) => {
                                    setRequiredLoanAmountProperty(e > 0);
                                }}
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <FormInput
                                label="借入額（その他）"
                                name="loanAmountOther"
                                type="number"
                                required
                                maxLength={10}
                                size={'large'}
                                labelClassName="content-step-form label-step-form"
                                suffix="万円"
                                onChange={(e) => {
                                    setRequiredLoanAmountOther(e > 0);
                                }}
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px] ant-col-upload">
                            <UploadImage
                                required={requiredLoanAmountProperty}
                                form={form}
                                initialImageUrl={data?.fileLoanProperty}
                                imageId={
                                    data?.fileLoanPropertyId
                                        ? Number(data?.fileLoanPropertyId)
                                        : undefined
                                }
                                name="fileLoanProperty"
                                title="借入証明（投資用不動産）をアップロード"
                                onChange={onChangeForm}
                                editName="isEditFileProperty"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px] ant-col-upload">
                            <UploadImage
                                required={requiredLoanAmountOther}
                                initialImageUrl={data?.fileLoanOther}
                                imageId={
                                    data?.fileLoanOtherId
                                        ? Number(data?.fileLoanOtherId)
                                        : undefined
                                }
                                form={form}
                                name="fileLoanOther"
                                title="借入証明（その他）をアップロード"
                                onChange={onChangeForm}
                                editName="isEditFileOther"
                            />
                        </Col>
                    </Row>
                </div>
            </Row>
        </>
    );
};
